<ion-header>
  <ion-toolbar>
    <ion-title>Neue Site anlegen</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
  <ion-grid>
    <ion-row class="ion-justify-content-center">
      <ion-col size="12" size-md="8" size-lg="6">
        <form [formGroup]="form" (ngSubmit)="submit()" novalidate>
          <ion-list lines="full">
            <!-- Name -->
            <ion-item>
              <ion-label position="stacked">Name<span style="color: var(--ion-color-danger)">*</span></ion-label>
              <ion-input formControlName="name" placeholder="z.B. Firmenstandort oder Anlagen Name"></ion-input>
            </ion-item>
            @if (form.controls.name.touched && form.controls.name.invalid) {
              <ion-note color="danger">
                Name ist erforderlich (min. 3 Zeichen)
              </ion-note>
            }

            <!-- Timezone (Modal mit Suche) -->
            <ion-item button detail (click)="openTimezoneModal()">
              <ion-label class="ion-text-wrap">
                <div>Zeitzone<span style="color: var(--ion-color-danger)">*</span></div>
                @if (!form.value.timezone) {
                  <ion-text color="medium">Tippen, um zu wählen…</ion-text>
                } @else {
                  <div><strong>{{ form.value.timezone }}</strong></div>
                }
              </ion-label>

            </ion-item>
            <ion-note color="medium">
              Verwenden Sie einen IANA-Zeitzonennamen (z. B. Europe/Vienna, UTC)
            </ion-note>
            @if (form.controls.timezone.touched && form.controls.timezone.invalid) {
              <ion-note color="danger">
                Zeitzone ist erforderlich
              </ion-note>
            }

            <!-- Setup Password -->
            <ion-item>
              <ion-label position="stacked">Setup-Passwort<span style="color: var(--ion-color-danger)">*</span></ion-label>
              <ion-input type="password" formControlName="setupPassword" placeholder="mind. 6 Zeichen"></ion-input>
            </ion-item>
            @if (form.controls.setupPassword.touched && form.controls.setupPassword.invalid) {
              <ion-note color="danger">
                Das Passwort muss mindestens 6 Zeichen lang sein
              </ion-note>
            }
          </ion-list>

          <ion-item lines="none" class="ion-padding-top">
            <ion-label position="stacked">Standort auf Karte wählen</ion-label>
          </ion-item>

          <div #map id="site-create-map"></div>

          <ion-note color="medium">
            Tipp: Auf die Karte tippen, um einen Marker zu setzen.
          </ion-note>

          <div class="ion-padding-top">
            <ion-button expand="block" type="submit" [disabled]="loading || form.invalid">
              @if (loading) {
                <ion-spinner name="crescent"></ion-spinner>
              } @else {
                <span>Erstellen</span>
              }

            </ion-button>
          </div>

        </form>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
